"use strict";

svg4everybody();
AOS.init({
  disable: 'false',
  offset: 200,
  duration: 600,
  easing: 'ease-in-sine',
  delay: 100,
  once: true
});
Fancybox.bind('[data-fancybox]', {
  Thumbs: false
});
if (document.querySelector('.phone-mask')) {
  document.querySelectorAll('.phone-mask').forEach(function (item) {
    Inputmask({
      "mask": "+7 (999) 999-99-99"
    }).mask(item);
  });
}
if (document.querySelector('.btn-modal') && document.querySelector('.modal')) {
  document.querySelectorAll('.modal').forEach(function (modalOther) {
    modalOther.addEventListener('click', function (event) {
      if (event.target == modalOther) {
        modalOther.classList.remove('active');
        document.querySelector('html').classList.remove('modal-open');
      }
    });
  });
  document.querySelectorAll('.btn-modal').forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      var container = event.target.getAttribute('data-modal');
      var additionalModalClass = event.target.getAttribute('data-class');
      var additionalModalSelector = false;
      var additionalModalSelectorJson = false;
      if (additionalModalClass) {
        additionalModalSelector = event.target.getAttribute("data-attributes");
        if (additionalModalSelector) additionalModalSelectorJson = JSON.parse(additionalModalSelector);
      }
      modalOpen(container, additionalModalClass, additionalModalSelectorJson);
      return false;
    }, false);
  });
}
if (document.querySelector('.modal .close')) {
  document.querySelectorAll('.modal .close').forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      var modal = event.target.closest('.modal');
      if (modal) {
        modal.classList.add('load');
        modal.classList.remove('active');
        setTimeout(function () {
          modal.classList.remove('load');
          document.querySelector('html').classList.remove('modal-open');
        }, 100);
      }
      return false;
    }, false);
  });
}
function modalOpen() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var classElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dataElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!id) return;
  var modal = document.getElementById(id);
  document.querySelectorAll('.modal').forEach(function (modalOther) {
    modalOther.classList.remove('active');
  });
  if (classElement) {
    var setElementModal = modal.querySelector(".".concat(classElement));
    if (dataElements && setElementModal) {
      Object.keys(dataElements).map(function (value) {
        if (dataElements[value]) setElementModal.setAttribute(value, dataElements[value]);
      });
    }
  }
  if (modal) {
    modal.classList.add('load');
    setTimeout(function () {
      modal.classList.remove('load');
      modal.classList.add('active');
      document.querySelector('html').classList.add('modal-open');
    }, 100);
  } else {
    document.querySelector('html').classList.remove('modal-open');
  }
  return false;
}
if (document.querySelector('.custom-scrollbar')) {
  document.querySelectorAll('.custom-scrollbar').forEach(function (item) {
    new SimpleBar(item, {
      autoHide: false
    });
  });
}
function scrollToForm(el) {
  if (document.querySelector(el)) {
    var yOffset = -60;
    var element = document.querySelector(el);
    var y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
}
if (document.querySelector('.js-scroll')) {
  document.querySelectorAll('.js-scroll').forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      var el = event.target.closest('.js-scroll').getAttribute('data-el');
      scrollToForm(el);
      return false;
    }, false);
  });
}
function scrollToTop(scrollDuration) {
  var cosParameter = window.scrollY / 2,
    scrollCount = 0,
    oldTimestamp = performance.now();
  function step(newTimestamp) {
    scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
    if (scrollCount >= Math.PI) window.scrollTo(0, 0);
    if (window.scrollY === 0) return;
    window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
    oldTimestamp = newTimestamp;
    window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);
}
if (document.querySelector('.js-scroll-top')) {
  document.querySelectorAll('.js-scroll-top').forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      var duration = event.target.closest('.js-scroll-top').getAttribute('data-duration');
      if (!duration) {
        duration = '500';
      }
      scrollToTop(duration);
      return false;
    }, false);
  });
}
function slideUp(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(function () {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}
function slideDown(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  target.style.removeProperty('display');
  var display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  var height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(function () {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}